import u from 'umbrellajs'
import { range } from 'rambda'
import { debounce } from 'rambdax'
import { onResize, onViewportChange } from './Responsive'

const enhanceTopDeck = topDeck => {
  const inner = u('.top-deck-inner', topDeck).first()
  let scrollWidth = document.body.clientWidth - 40
  let totalWidth = inner.scrollWidth - 40

  // Enable Click for all cards with [click-url] set
  u('.card[data-click-url]', topDeck).on('click', function(event){
    // Omniture Tracking
    const position = Array.from(inner.children).indexOf(this) + 1
    // @TODO: We should have a stricter/easier to understand api for calling this, something like:
    //
    // omniTrack('TOP_PICKS_CLICK', position)
    //
    // If we expose tracking based on a typed ENUM this way we can make it much easier to reason
    // and verify what we are even doing in the first place.
    sessionStorage.setItem('eVar9', position)

    // Exclude elements that have their own click events from using click-url
    if(['BUTTON', 'A'].includes(event.target.tagName)){ return false; }
    const href = u(this).data('click-url')
    window.location = href
  })

  // Mobile Scrolling Functionality
  const $left = u('.deck-left', topDeck)
  const $right = u('.deck-right', topDeck)

  const setScroll = offset => inner.scroll({left: offset, behaviour: 'smooth'})
  const adjustScroll = offset => () => setScroll(inner.scrollLeft + offset)
  const adjustLeft = adjustScroll((scrollWidth * -1))
  const adjustRight = adjustScroll(scrollWidth)

  // We will only bind when the elements are present
  if($left.length && $right.length){
    $left.handle('click', adjustLeft)
    $right.handle('click', adjustRight)
  }

  // Mobile paignation dots. Updates the DOM based on the current window state
  const $dots = u('.pagination-dots', topDeck)
  const renderDots = () => {
    if($dots.length === 0){ return; }
    const dotCount = Math.ceil(totalWidth / scrollWidth)
    const $elements = u(range(0, dotCount))
          .map(i => `<button value="${i}" />`)
          .handle('click', e => {
            setScroll((totalWidth / dotCount) * parseInt(e.target.value, 10))
            $dots.find('.active').removeClass('active')
            u(e.target).addClass('active')
          })
    $dots.children().remove()
    $dots.append($elements)
  }

  // Handle event for scrolling mobile scrolling
  let hideLeft = null
  let hideRight = null
  const handleInnerScroll = debounce(() => {
    const isLeftHidden = () => inner.scrollLeft <= 40
    const isRightHidden = () => inner.scrollLeft + 40 >= totalWidth - scrollWidth
    if(hideLeft != isLeftHidden()){ hideLeft = isLeftHidden(); $left.toggleClass('hidden', hideLeft) }
    if(hideRight != isRightHidden()){ hideRight = isRightHidden(); $right.toggleClass('hidden', hideRight) }
    $dots.find('.active').removeClass('active')
    const dotPos = Math.ceil( inner.scrollLeft / scrollWidth )
    $dots.find(`:nth-child(${dotPos + 1})`).addClass('active')
  }, 25)
  inner.addEventListener('scroll', handleInnerScroll, {passive : false})

  // sidebar/ad-area resizer
  // @HACK: Due to a limition in grids there is not a way to simply set 1/($rows+2) so
  // we will do it here in JS to allow for a sidebar that consistently tracks the height
  // against the amount of cards being shown next to it.
  const cardCount = u('.card', inner).length
  u('.sidebar-area, .ad-area', topDeck)
    .each(element => { element.style['grid-row'] = `1/${Math.ceil(cardCount / 3) + 2}` })

  // When the document is finished loading or the size of the window changes we want
  // to resync the cards to ensure they are displaying correctly.
  const syncCards = viewport => {
    // Ensure we have the correct amount of dots
    scrollWidth = document.body.clientWidth - 40
    totalWidth = inner.scrollWidth - 40
    renderDots()
    handleInnerScroll()

    // Responsive Sidebar Area
    // @NOTE: The sidebar area on mobile will want to be on a seperate row. Doing this with
    // css would be very hacky without a better css solution for sidebar positioning
    // within a grid.
    if(typeof viewport === 'undefined'){ return }
    const sidebar = u('.sidebar-area', topDeck).remove()
    if(sidebar.length === 0){ return; }
    if(viewport === 'desktop'){
      u(inner).prepend(sidebar)
    } else {
      u(topDeck).prepend(sidebar)
    }
  }
  onResize(syncCards)
  syncCards()

  // Unbind/Unload
  return () => {
    u(inner).off(handleInnerScroll)
    $left.off(adjustLeft)
    $right.off(adjustRight)
    $dots.find('*').remove()
  }
}


export default function Cards(){
  // Initialise all top decks in their own closure
  const unloads = u('.top-deck').nodes.map(enhanceTopDeck)
  window.addEventListener('unload', unloads[0])
}
